import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  
  private loadingMap = new Map<string, BehaviorSubject<boolean>>();

 
  getLoading(context: string = 'global'): BehaviorSubject<boolean> {
    if (!this.loadingMap.has(context)) {
      this.loadingMap.set(context, new BehaviorSubject<boolean>(false));
    }
    return this.loadingMap.get(context)!;
  }

  
  getLoadingAsObservable(context: string = 'global'): Observable<boolean> {
    return this.getLoading(context).asObservable();
  }

  setLoading(isLoading: boolean, context: string = 'global'): void {
    this.getLoading(context).next(isLoading);
  }

  startLoading(context: string = 'global'): void {
    this.setLoading(true, context);
  }

  
  stopLoading(context: string = 'global'): void {
    this.setLoading(false, context);
  }

  isLoading(context: string = 'global'): boolean {
    return this.getLoading(context).getValue();
  }
}
